import { ColumnChart } from '..'

const CATEGORIES = ['5 - 10%', '10 - 15%', '15 - 20%', '20 - 25%', '25 - 30%']

const TOOLTIP_FORMATTER = that => {
  const { category, y: trades } = that.point as any

  return `<div class="column-chart-tooltip-wrapper"><h2>${category}</h2><p>Trades: ${trades}</p></div>`
}

interface Props {
  targetVolatilities: { x: number; y: number }[]
}
export const TargetVolatilityColumnChart = ({ targetVolatilities }: Props) => (
  <ColumnChart
    categories={CATEGORIES}
    data={targetVolatilities}
    tooltipFormatter={TOOLTIP_FORMATTER}
  />
)
